import React, { Component } from 'react';
import { Row, Col, Grid, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid'
import { Data } from 'react-data-grid-addons';
import { fetchInv } from '../../../actions/products_actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import { SkyLightStateless } from 'react-skylight';
import PoListModal from './PoListModal';
import SoListModal from './SoListModal';


const styles = {
  table: {
    display: 'flex',
    flexDirection: 'row',
    width: '560px',
    alignItems: 'center',
  },
  tx_blue: {
    color: 'blue',
    width: '100%',
  },
  poStyle: {
    width: '660px',
    height: '400px',
    marginLeft: '-9%',
  },
  soStyle: {
    width: '830px',
    height: '400px',
    marginLeft: '-14%',
  },
}

class InvModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poLines: [],
      poVisible: false,
      rows: [],
      soLines: [],
      soVisible: false,

    };
    this.handleClosePoVisible = this.handleClosePoVisible.bind(this);
    this.handleCloseSoVisible = this.handleCloseSoVisible.bind(this);
  }

  componentDidMount() {
    this.fetchInvData(this.props.productId, this.props.companyId, this.props.warehouseId);
  }

  fetchInvData = (id, companyId, warehouseId) => {
    fetchInv(id, companyId, warehouseId, (data) => {
      let colorKeys = Object.keys(data);
      let rows = colorKeys.map(color => {
        return { color, ...data[color] };
      });
      this.setState({
        rows,
      })
    })
  }

  handleClosePoVisible = () => {
    this.setState({
      poVisible: false,
      poLines: [],
    })
  }

  handleCloseSoVisible = () => {
    this.setState({
      soVisible: false,
      soLines: [],
    })
  }

  render() {
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }
    const columns = [
      {
        key: 'color',
        name: <Translate value="color" />,
        resizable: true,
        formatter: ({ value }) => {
          return <div>
            {value && value != null ? value : ''}
          </div>
        }
      },
      {
        key: 'po_qty',
        name: <Translate value="po_qty" />,
        resizable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <div style={styles.tx_blue}
            onClick={() => {
              this.setState({
                poLines: dependentValues.po_lines,
                poVisible: true,
              })
            }}
          >
            {dependentValues.po_qty}
          </div>
        }
      },
      {
        key: 'so_qty',
        name: <Translate value="commit_qty" />,
        resizable: true,
        width: 160,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <div style={styles.tx_blue}
            onClick={() => {
              this.setState({
                soLines: dependentValues.so_lines,
                soVisible: true,
              })
            }}
          >
            {dependentValues.so_qty}
          </div>
        }
      },
      {
        key: 'inv_qty',
        name: <Translate value="inventory" />,
        resizable: true,
        formatter: ({ value }) => {
          return <div>
            {value || 0}
          </div>
        }
      },
      {
        key: 'balance',
        name: <Translate value="balance" />,
        resizable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <div>
            {(dependentValues.po_qty || 0) - (dependentValues.so_qty || 0) + (dependentValues.inv_qty || 0)}
          </div>
        }
      },
    ];
    return (
      <Grid>
        <div id='productInv' style={styles.table}>
          <ReactDataGrid
            rowKey="id"
            rowHeight={25}
            columns={columns}
            minHeight={300}
            rowGetter={rowGetter}
            rowsCount={getSize()}
          />
        </div>
        <SkyLightStateless
          dialogStyles={styles.poStyle}
          isVisible={this.state.poVisible}
          onCloseClicked={() => { this.handleClosePoVisible(); }}
          title={<Translate value='po_list' />}
        >
          <PoListModal
            poLines={this.state.poLines}
            close={() => {
              this.handleClosePoVisible();
            }}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={styles.soStyle}
          isVisible={this.state.soVisible}
          onCloseClicked={() => { this.handleCloseSoVisible(); }}
          title={<Translate value='so_list' />}
        >
          <SoListModal
            soLines={this.state.soLines}
            close={() => {
              this.handleCloseSoVisible();
            }}
          />
        </SkyLightStateless>
      </Grid>
    )
  }
}

export default InvModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/InvModal.jsx